export const SessionDataMap = {
  'cacheData.data.AriesSearch.searchCriteria.availabilityRequestVO.lengthOfStay': 'lengthOfStay',
  'cacheData.data.AriesReservation.propertyId': 'propertyId',
  'cacheData.data.AriesReservation.ersProperty': 'isErs',
  'cacheData.data.AriesReservation.inAuthID': 'inAuthID',
  'cacheData.data.AriesSearch.searchCriteria.availabilityRequestVO.checkInDate': 'checkInDate',
  'cacheData.data.AriesSearch.searchCriteria.availabilityRequestVO.checkOutDate': 'checkOutDate',
  'cacheData.data.AriesSearch.searchCriteria.availabilityRequestVO.numRooms': 'numRooms',
  'cacheData.data.AriesCommon.memState': 'userState',
  'cacheData.data.consumerID': 'consumerID',
  'cacheData.data.AriesSearch.searchCriteria.availabilityRequestVO.clusterCode': 'clusterCode',
  'cacheData.data.travelAgentIataNumber': 'iataNumber',
  'cacheData.data.AriesSearch.searchCriteria.availabilityRequestVO.corporateCode': 'corporateCode',
  'cacheData.data.AriesSearch.searchCriteria.availabilityRequestVO.groupCode': 'groupCode',
  'cacheData.data.AriesSearch.searchCriteria.availabilityRequestVO.rewardsRedemption': 'rewardsRedemption',
  'cacheData.data.AriesReservation.confirmationNumber': 'confirmationNumber',
  'cacheData.data.AriesReservation.isACRS': 'isACRS',
  'cacheData.data.AriesReservation.crsSystem': 'crsSystem',
  'cacheData.data.AriesSearch.searchCriteria.showFullPrice': 'showFullPrice',
  'cacheData.data.AriesReservation.tripsXRequestedByHeader': 'tripsXRequestedByHeader',
  'cacheData.data.AriesSearch.searchCriteria.selectedCurrency': 'searchSelectedCurrency',
  'cacheData.data.AriesReservation.selectedCurrency': 'resSelectedCurrency',
  'cacheData.data.AriesReservation.propertyCurrency': 'propertyCurrency',
  locale: 'locale',
  authenticated: 'isAuth',
  'cacheData.data.AriesReservation.isMax': 'isMax',
  'cacheData.data.AriesReservation.brandCode': 'brandCode',
};

export const ImagesDataMap = {
  hotelPhotoTours: 'hotelPhotoTours',
  'property.contactInformation.address.country.code': 'countryCode',
};

export const NRPDetailsMap = {
  'commerce.product.productById.availableAddOnsRelationship.nonRoomProductAddOns': 'nonRoomProductList',
  'commerce.product.productById.basicInformation.sourceOfRate': 'sourceOfRate',
  'commerce.product.productById.media.photoGallery.edges[0].node': 'productImages',
};
